export const BASE_API_URL = process.env.REACT_APP_API_URL || "http://localhost:5000";

// Fonction interne de base pour fetch
const baseFetch = async (endpoint, options = {}) => {
    
    // 1. Plus besoin de récupérer le token dans le localStorage !
    // Le navigateur enverra automatiquement le cookie "token".

    const headers = {
        'Content-Type': 'application/json',
        ...options.headers,
    };

    const fullUrl = `${BASE_API_URL}${endpoint.startsWith('/') ? endpoint : '/' + endpoint}`;

    // 2. L'option CRITIQUE : credentials: 'include'
    // Sans cette ligne, le navigateur refuse d'envoyer le cookie vers ton API.
    const response = await fetch(fullUrl, {
        ...options,
        headers,
        credentials: 'include', 
    });

    // 3. Gestion de l'expiration de session
    if (response.status === 401 || response.status === 403) {
        // Le serveur nous dit que le cookie n'est plus valide ou manquant
        localStorage.removeItem('user'); // On nettoie les infos profils (nom, role, etc.)
        // Optionnel: window.location.href = '/login';
    }

    return response;
};

// ⭐ OBJET AVEC MÉTHODES (Plus besoin de passer de token en paramètre)
export const authFetch = {
    get: (url, options) => baseFetch(url, { ...options, method: 'GET' }),
    
    post: (url, body, options) => baseFetch(url, { 
        ...options, 
        method: 'POST', 
        body: JSON.stringify(body) 
    }),
    
    put: (url, body, options) => baseFetch(url, { 
        ...options, 
        method: 'PUT', 
        body: JSON.stringify(body) 
    }),
    
    delete: (url, options) => baseFetch(url, { ...options, method: 'DELETE' }),
};